<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Encaminhamento"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-select
                        :disabled="!!item"
                        :options="data.form.encaminhamento.encaminhamentos"
                        :validations="validations.tipo"
                        @change="handleTipoChange"
                        label="Tipo"
                        show-default-option
                        text-field="descricao"
                        v-model="model.tipoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <template v-if="model.tipoId === enums.encaminhamento.ENCAMINHAMENTO_INTERSETORIAL">
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!!item"
                            :options="data.form.encaminhamento.intersetorial.unidades"
                            :validations="validations.unidade"
                            @change="handleUnidadeChange"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!!item"
                            :options="data.form.encaminhamento.intersetorial.infraestruturas"
                            :validations="validations.infraestrutura"
                            label="Local de atendimento"
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                            show-default-option
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :disabled="!!item"
                            :repository="repositories.geral.ciap"
                            :request-query-string-params="{sexo_id: data.additionals.paciente.sexoId, show_all: true}"
                            :search-fields="fields.autocomplete.ciap"
                            :text-field="(item) => `${item.codigo} - ${item.descricao}`"
                            @select="handleCiapSelect"
                            label="CIAP 2"
                            v-model="model.ciap"
                        />
                    </rkm-col>

                    <rkm-col cols="6" v-if="!model.sugestao">
                        <rkm-form-input-autocomplete
                            :repository="repositories.cid"
                            :request-query-string-params="{
                                sexo: data.additionals.paciente.sexoIdentificador,
                            }"
                            :results-limit= "20"
                            :search-fields="fields.autocomplete.cid"
                            :text-field="(item) => `${item.codigo} - ${item.nome}`"
                            label="CID 10"
                            v-model="model.cid"
                            :validations="validations.cid"
                            :disabled="!!item"
                        >

                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group
                                        v-model="model.sugestao"
                                        :disabled="data.cidSugestao.length === 0"
                                    >
                                        <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                        <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-input-autocomplete>
                    </rkm-col>

                    <rkm-col cols="6" v-else>
                        <rkm-form-select
                            :options="data.cidSugestao"
                            label="CID 10"
                            show-default-option
                            text-field="codigoNome"
                            v-model="model.cidId"
                            value-field="id"
                            :disabled="!!item"
                        >

                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group v-model="model.sugestao">
                                        <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                        <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-select>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-else-if="model.tipoId === enums.encaminhamento.ENCAMINHAMENTO_PARA_SERVICO_ESPECIALIZADO">
                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :repository="repositories.especialidade"
                            :request-query-string-params="{ encaminhamento: true }"
                            :search-fields="fields.autocomplete.especialidade"
                            label="Especialidade"
                            :validations="validations.especialidade"
                            :text-field="i => i.ocupacaoCodigo ? `${i.ocupacaoCodigo} - ${i.nome}` : (i.descricao || i.nome)"
                            v-model="model.especialidade"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-input
                            :validations="validations.complemento"
                            label="Complemento"
                            v-model="model.complemento"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :disabled="!!item"
                            :repository="repositories.geral.ciap"
                            :request-query-string-params="{sexo_id: data.additionals.paciente.sexoId, show_all: true}"
                            :search-fields="fields.autocomplete.ciap"
                            :text-field="(item) => `${item.codigo} - ${item.descricao}`"
                            :validations="validations.ciap"
                            @select="handleCiapSelect"
                            label="CIAP 2"
                            v-model="model.ciap"
                        />
                    </rkm-col>

                    <rkm-col cols="6" v-if="!model.sugestao">
                        <rkm-form-input-autocomplete
                            :repository="repositories.cid"
                            :request-query-string-params="{
                                sexo: data.additionals.paciente.sexoIdentificador,
                            }"
                            :results-limit= "20"
                            :search-fields="fields.autocomplete.cid"
                            :text-field="(item) => `${item.codigo} - ${item.nome}`"
                            label="CID 10"
                            v-model="model.cid"
                            :validations="validations.cid"
                        >

                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group
                                        v-model="model.sugestao"
                                        :disabled="data.cidSugestao.length === 0"
                                    >
                                        <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                        <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-input-autocomplete>
                    </rkm-col>

                    <rkm-col cols="6" v-else>
                        <rkm-form-select
                            :options="data.cidSugestao"
                            label="CID 10"
                            show-default-option
                            text-field="codigoNome"
                            v-model="model.cidId"
                            value-field="id"
                        >

                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group v-model="model.sugestao">
                                        <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                        <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-select>
                    </rkm-col>
                </rkm-row>

                <BoxClassificacaoRisco :data="classificacaoRiscoData" :encaminhamento="true" />

                <BoxAntropometria
                    :data="{form: data.objetivoForm, model: data.objetivoModel}"
                    :hidden-fields="['perimetroPanturrilha', 'perimetroCefalico', 'imc', 'comprimentoPeDireito']"
                    :required="isRequired"
                />

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-textarea
                            :validations="validations.motivo"
                            label="Motivo"
                            rows="4"
                            maxlength="5000"
                            v-model="model.motivo"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-textarea
                            :validations="validations.observacao"
                            label="Observações"
                            rows="4"
                            maxlength="500"
                            v-model="model.observacao"
                        />
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-else-if="model.tipoId === enums.encaminhamento.ENCAMINHAMENTO_PARA_CAPS">
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :disabled="!!item"
                            :repository="repositories.geral.ciap"
                            :request-query-string-params="{sexo_id: data.additionals.paciente.sexoId, show_all: true}"
                            :search-fields="fields.autocomplete.ciap"
                            :text-field="(item) => `${item.codigo} - ${item.descricao}`"
                            @select="handleCiapSelect"
                            label="CIAP 2"
                            v-model="model.ciap"
                        />
                    </rkm-col>

                    <rkm-col cols="6" v-if="!model.sugestao">
                        <rkm-form-input-autocomplete
                            :repository="repositories.cid"
                            :request-query-string-params="{
                                sexo: data.additionals.paciente.sexoIdentificador,
                            }"
                            :results-limit= "20"
                            :search-fields="fields.autocomplete.cid"
                            :text-field="(item) => `${item.codigo} - ${item.nome}`"
                            label="CID 10"
                            v-model="model.cid"
                            :validations="validations.cid"
                            :disabled="!!item"
                        >

                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group
                                        v-model="model.sugestao"
                                        :disabled="data.cidSugestao.length === 0"
                                    >
                                        <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                        <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-input-autocomplete>
                    </rkm-col>

                    <rkm-col cols="6" v-else>
                        <rkm-form-select
                            :options="data.cidSugestao"
                            label="CID 10"
                            show-default-option
                            text-field="codigoNome"
                            v-model="model.cidId"
                            value-field="id"
                            :disabled="!!item"
                        >

                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group v-model="model.sugestao">
                                        <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                        <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-select>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-textarea
                            :validations="{max: 5000}"
                            label="Motivo"
                            maxlength="5000"
                            rows="4"
                            v-model="model.motivo"
                        />
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-else>
                <rkm-row v-if="!!model.tipoId">
                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :disabled="!!item"
                            :repository="repositories.geral.ciap"
                            :request-query-string-params="{sexo_id: data.additionals.paciente.sexoId, show_all: true}"
                            :search-fields="fields.autocomplete.ciap"
                            :text-field="(item) => `${item.codigo} - ${item.descricao}`"
                            @select="handleCiapSelect"
                            label="CIAP 2"
                            v-model="model.ciap"
                        />
                    </rkm-col>

                    <rkm-col cols="6" v-if="!model.sugestao">
                        <rkm-form-input-autocomplete
                            :repository="repositories.cid"
                            :request-query-string-params="{
                                sexo: data.additionals.paciente.sexoIdentificador,
                            }"
                            :results-limit= "20"
                            :search-fields="fields.autocomplete.cid"
                            :text-field="(item) => `${item.codigo} - ${item.nome}`"
                            label="CID 10"
                            v-model="model.cid"
                            :validations="validations.cid"
                            :disabled="!!item"
                        >

                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group
                                        v-model="model.sugestao"
                                        :disabled="data.cidSugestao.length === 0"
                                    >
                                        <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                        <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-input-autocomplete>
                    </rkm-col>

                    <rkm-col cols="6" v-else>
                        <rkm-form-select
                            :options="data.cidSugestao"
                            label="CID 10"
                            show-default-option
                            text-field="codigoNome"
                            v-model="model.cidId"
                            value-field="id"
                            :disabled="!!item"
                        >

                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group v-model="model.sugestao">
                                        <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                        <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-select>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-if="Number(model.tipoId) === enums.encaminhamento.ENCAMINHAMENTO_PARA_INTERNACAO_HOSPITALAR">
                <EncaminhamentoInternacao
                    ref="Form"
                    :data="data"
                    :model="model"
                />
            </template>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{item ? 'Salvar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import BoxClassificacaoRisco from '@/components/ambulatorio/components/classificacao-risco/Index'
import BoxAntropometria from '@/components/ambulatorio/components/antropometria/Index'
import EncaminhamentoInternacao from './components/encaminhamento-internacao/Form'

// Enums.
import encaminhamento from '@/enums/atencao-basica/atendimento-individual/encaminhamento'
import classificacaoRisco from '@/enums/ambulatorio/classificacaoRisco'

// Mixins.
import {object, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

// moment
import moment from 'moment'

export default {
    components: {BoxClassificacaoRisco, BoxAntropometria, EncaminhamentoInternacao},
    computed: {
        classificacaoRiscoData() {
            return {
                form: this.data.form.encaminhamento.servicoEspecializado,
                model: this.model,
            }
        },
        validations() {
            return {
                tipo: {required: true},
                unidade: {required: true},
                infraestrutura: {required: true},
                especialidade: {required: true},
                cid: {required: this.model.ciap ? false : true},
                ciap: {required: !this.model.cid && !this.model.cidId},
                complemento: {max: 100},
                motivo: {max: 5000},
                observacao: {max: 500},
            }
        },
        isRequired() {

            const especialidade = this.data.form.encaminhamento.servicoEspecializado.especialidades.find(especialidade => especialidade.id === this.model.especialidadeId)

            if (especialidade) {

                 return especialidade.exigirPesoAlturaCircunferencia
            }

            return false
        }
    },
    created() {
        this.repositories = {
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento'),
            cid: this.getConectaSusRepository('sigtap.cid'),
            geral: this.getConectaSusRepository('geral'),
            especialidade: this.getConectaSusRepository('cadastro.especialidade'),
        }
    },
    data: () => ({
        enums: {encaminhamento, classificacaoRisco},
        fields: {
            autocomplete: {
                ciap: [
                    {key: 'geral_ciap.codigo', searchable: true},
                    {key: 'geral_ciap.descricao', searchable: true},
                ],
                cid: [
                    {key: 'codigo', searchable: true},
                    {key: 'nome', searchable: true},
                ],
                especialidade:[
                    {key: 'especialidade.nome', searchable: true},
                    {key: 'sigtap.ocupacao.codigo', searchable: true}

                ]
            },
        },
        form: {infraestruturas: []},
        item: null,
        model: {
            tipoId: null,
            unidadeId: null,
            infraestruturaId: null,
            especialidade: null,
            complemento: null,
            ciap: null,
            cid: null,
            cidId: null,
            classificacaoRiscoId: null,
            motivo: null,
            observacao: null,
            sugestao: false,
            internacaoHospitalar: {
                cidPrincipal: null,
                cidSecundario: null,
                cidCausasAssociadas: null,
                unidadeSolicitanteId: null,
                principaisSinaisSintomasClinicos: null,
                condicoesQueJustificamInternacao: null,
                principaisResultadosDeProvasDiagnosticas: null,
                procedimento: {
                    procedimentoSolicitado: null,
                    dataSolicitacao: null,
                    clinicaId: null,
                    caraterInternacaoId: null,
                    profissionalSolicitanteAssistente: null,
                    profissionalSolicitanteDocumentoTipoId: null,
                    profissionalSolicitanteDocumentoNumero: null
                },
                causasExternas: {
                    causaExternaId: null,
                    cnpjSeguradora: null,
                    numeroBilhete: null,
                    serie: null,
                    cnpjEmpresa: null,
                    cnaeEmpresa: null,
                    cbor: null,
                    vinculoPrevidenciaId: null,
                },
                autorizacao: {
                    profissionalAutorizador: null,
                    dataAutorizacao: null,
                    codigoOrgaoEmissor: null,
                    profissionalAutorizadorDocumentoTipoId: null,
                    profissionalAutorizadorDocumentoNumero: null
                }
            },
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item = null) {
            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.model.sugestao = this.data.cidSugestao.length > 0

            this.$refs.RkmModal.show()
        },
        formatDate(data) {
            if (!data) return ''

            return moment(data, ['YYYY-MM-DD']).format('YYYY-MM-DDTHH:mm:ss.SSSZ')
        },
        create() {
            this.resetForm()
        },
        edit() {
            if (!this.item) return

            const internacao = this.item.internacaoHospitalar || {}
            const procedimento = internacao.procedimento || {}
            const causasExternas = internacao.causasExternas || {}
            const autorizacao = internacao.autorizacao || {}

            this.model.internacaoHospitalar = {
                procedimento: {},
                causasExternas: {},
                autorizacao: {}
            }

            Object.assign(this.model, {
                tipoId: Number(this.item.tipo?.id),
                unidadeId: this.item.unidade?.id ?? null,
                infraestruturaId: this.item.infraestrutura?.id ?? null,
                especialidade: this.item.especialidade,
                complemento: this.item.complemento,
                ciap: this.item.ciap,
                cid: this.item.cid,
                cidId: this.data.cidSugestao.length > 0 ? this.item.cid?.id : null,
                classificacaoRiscoId: this.item.classificacaoRisco
                    ? this.item.classificacaoRisco.id : this.enums.classificacaoRisco.NAO_AGUDA,
                motivo: this.item.motivo,
                observacao: this.item.observacao,
                sugestao: false,
            })

            Object.assign(this.model.internacaoHospitalar, {
                unidadeSolicitanteId: internacao.unidadeSolicitanteId ?? null,
                cidPrincipal: internacao.cidPrincipal ?? null,
                cidSecundario: internacao.cidSecundario ?? null,
                cidCausasAssociadas: internacao.cidCausasAssociadas ?? null,
                principaisSinaisSintomasClinicos: internacao.principaisSinaisSintomasClinicos,
                condicoesQueJustificamInternacao: internacao.condicoesQueJustificamInternacao,
                principaisResultadosDeProvasDiagnosticas: internacao.principaisResultadosDeProvasDiagnosticas,
            })

            Object.assign(this.model.internacaoHospitalar.procedimento, {
                procedimentoSolicitado: procedimento.procedimentoSolicitado,
                dataSolicitacao: this.formatDate(procedimento.dataSolicitacao),
                clinicaId: procedimento.clinicaId,
                caraterInternacaoId: procedimento.caraterInternacaoId,
                profissionalSolicitanteDocumentoTipoId: procedimento.profissionalSolicitanteAssistenteDocumentoTipoId ?? procedimento.profissionalSolicitanteDocumentoTipoId,
                profissionalSolicitanteDocumentoNumero: procedimento.profissionalSolicitanteAssistenteDocumentoNumero ?? procedimento.profissionalSolicitanteDocumentoNumero,
                profissionalSolicitanteAssistente: procedimento.profissionalSolicitanteAssistente
            })

            Object.assign(this.model.internacaoHospitalar.causasExternas, {
                causaExternaId: causasExternas.causaExternaId ?? null,
                cnpjSeguradora: causasExternas.cnpjSeguradora ?? null,
                numeroBilhete: causasExternas.numeroBilhete ?? null,
                serie: causasExternas.serie ?? null,
                cnpjEmpresa: causasExternas.cnpjEmpresa ?? null,
                cnaeEmpresa: causasExternas.cnaeEmpresa ?? null,
                cbor: causasExternas.cbor ?? null,
                vinculoPrevidenciaId: causasExternas.vinculoPrevidenciaId ?? null,
            })

            Object.assign(this.model.internacaoHospitalar.autorizacao, {
                profissionalAutorizador: autorizacao.profissionalAutorizador,
                dataAutorizacao: this.formatDate(autorizacao.dataAutorizacao),
                codigoOrgaoEmissor: autorizacao.codigoOrgaoEmissor ?? null,
                profissionalAutorizadorDocumentoTipoId: autorizacao.profissionalAutorizadorDocumentoTipoId,
                profissionalAutorizadorDocumentoNumero: autorizacao.profissionalAutorizadorDocumentoNumero,
            })

            this.model.internacaoHospitalar = JSON.parse(
                JSON.stringify(this.model.internacaoHospitalar)
            )

            if (this.item.infraestrutura) {

                this.handleUnidadeChange(this.model.unidadeId, () => this.model.infraestruturaId = this.item.infraestrutura.id)
            }
        },
        store() {

            let cid = null

            if (this.model.sugestao) {

                const cidSelecionado = this.data.cidSugestao.find(c => c.id == this.model.cidId)

                if (cidSelecionado) {

                    cid = {
                        id: cidSelecionado.id,
                        codigo: cidSelecionado.codigo,
                        nome: cidSelecionado.nome,
                    }
                }
            } else {

                cid = this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null
            }
            const tipo = this.data.form.encaminhamento.encaminhamentos.find(encaminhamento => encaminhamento.id === this.model.tipoId)
            const unidade = this.data.form.encaminhamento.intersetorial.unidades.find(unidade => unidade.id === this.model.unidadeId)
            const infraestrutura = this.data.form.encaminhamento.intersetorial.infraestruturas.find(infraestrutura => infraestrutura.id === this.model.infraestruturaId)
            const especialidade = this.model.especialidade
            const classificacaoRisco = this.data.form.encaminhamento.servicoEspecializado.classificacoesRisco.find(classificacaoRisco => classificacaoRisco.id === this.model.classificacaoRiscoId)
            this.data.model.encaminhamentos.push({
                tipo: {
                    id: tipo.id,
                    descricao: tipo.descricao,
                },
                unidade: this.model.unidadeId ? {
                    id: unidade.id,
                    nomeFantasia: unidade.nomeFantasia
                } : null,
                infraestrutura: this.model.infraestruturaId ? {
                    id: infraestrutura.id,
                    nome: infraestrutura.nome,
                } : null,
                especialidade: this.model.especialidade ? {
                    id: especialidade.id,
                    nome: especialidade.nome,
                    descricao: especialidade.nome,
                    ocupacaoCodigo: especialidade.ocupacaoCodigo,
                    exigirPesoAlturaCircunferencia: especialidade.exigirPesoAlturaCircunferencia,
                } : null,
                complemento: this.model.complemento,
                ciap: this.model.ciap ? {
                    id: this.model.ciap.id,
                    codigo: this.model.ciap.codigo,
                    descricao: this.model.ciap.descricao,
                } : null,
                cid: cid,
                classificacaoRisco: this.model.classificacaoRiscoId ? {
                    id: classificacaoRisco.id,
                    nome: classificacaoRisco.nome,
                    descricaoEncaminhamento: classificacaoRisco.descricaoEncaminhamento
                } : null,
                motivo: this.model.motivo,
                observacao: this.model.observacao,
                internacaoHospitalar: {
                    cidPrincipal: this.model.internacaoHospitalar.cidPrincipal,
                    cidSecundario: this.model.internacaoHospitalar.cidSecundario ? {
                        id: this.model.internacaoHospitalar.cidSecundario.id
                    } : null,
                    cidCausasAssociadas: this.model.internacaoHospitalar.cidCausasAssociadas ? {
                        id: this.model.internacaoHospitalar.cidCausasAssociadas.id
                    } : null,
                    unidadeSolicitanteId: this.model.internacaoHospitalar.unidadeSolicitanteId,
                    principaisSinaisSintomasClinicos: this.model.internacaoHospitalar.principaisSinaisSintomasClinicos,
                    condicoesQueJustificamInternacao: this.model.internacaoHospitalar.condicoesQueJustificamInternacao,
                    principaisResultadosDeProvasDiagnosticas: this.model.internacaoHospitalar.principaisResultadosDeProvasDiagnosticas,
                    procedimento: {
                        procedimentoSolicitado: this.model.internacaoHospitalar.procedimento.procedimentoSolicitado,
                        dataSolicitacao: this.model.internacaoHospitalar.procedimento.dataSolicitacao,
                        clinicaId: this.model.internacaoHospitalar.procedimento.clinicaId,
                        caraterInternacaoId: this.model.internacaoHospitalar.procedimento.caraterInternacaoId,
                        profissionalSolicitanteAssistente: this.model.internacaoHospitalar.procedimento.profissionalSolicitanteAssistente,
                        profissionalSolicitanteDocumentoTipoId: this.model.internacaoHospitalar.procedimento.profissionalSolicitanteDocumentoTipoId,
                        profissionalSolicitanteDocumentoNumero: this.model.internacaoHospitalar.procedimento.profissionalSolicitanteDocumentoNumero?.replace(/\D/g, '')
                    },
                    causasExternas: {
                        causaExternaId: this.model.internacaoHospitalar.causasExternas.causaExternaId,
                        cnpjSeguradora: this.model.internacaoHospitalar.causasExternas.cnpjSeguradora?.replace(/\D/g, ''),
                        numeroBilhete: this.model.internacaoHospitalar.causasExternas.numeroBilhete,
                        serie: this.model.internacaoHospitalar.causasExternas.serie,
                        cnpjEmpresa: this.model.internacaoHospitalar.causasExternas.cnpjEmpresa?.replace(/\D/g, ''),
                        cnaeEmpresa: this.model.internacaoHospitalar.causasExternas.cnaeEmpresa?.replace(/\D/g, ''),
                        cbor: this.model.internacaoHospitalar.causasExternas.cbor,
                        vinculoPrevidenciaId: this.model.internacaoHospitalar.causasExternas.vinculoPrevidenciaId,
                    },
                    autorizacao: {
                        profissionalAutorizador: this.model.internacaoHospitalar.autorizacao.profissionalAutorizador,
                        dataAutorizacao: this.model.internacaoHospitalar.autorizacao.dataAutorizacao,
                        codigoOrgaoEmissor: this.model.internacaoHospitalar.autorizacao.codigoOrgaoEmissor,
                        profissionalAutorizadorDocumentoTipoId: this.model.internacaoHospitalar.autorizacao.profissionalAutorizadorDocumentoTipoId,
                        profissionalAutorizadorDocumentoNumero: this.model.internacaoHospitalar.autorizacao.profissionalAutorizadorDocumentoNumero?.replace(/\D/g, '')
                    }
                },
            })
        },
        update() {

            let cid = null

            if (this.model.sugestao) {

                const cidSelecionado = this.data.cidSugestao.find(c => c.id == this.model.cidId)

                if (cidSelecionado) {

                    cid = {
                        id: cidSelecionado.id,
                        codigo: cidSelecionado.codigo,
                        nome: cidSelecionado.nome,
                    }
                }
            } else {

                cid = this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null
            }

            const tipo = this.data.form.encaminhamento.encaminhamentos.find(encaminhamento => encaminhamento.id === this.model.tipoId)
            const unidade = this.data.form.encaminhamento.intersetorial.unidades.find(unidade => unidade.id === this.model.unidadeId)
            const infraestrutura = this.data.form.encaminhamento.intersetorial.infraestruturas.find(infraestrutura => infraestrutura.id === this.model.infraestruturaId)
            const especialidade = this.model.especialidade
            const classificacaoRisco = this.data.form.encaminhamento.servicoEspecializado.classificacoesRisco.find(classificacaoRisco => classificacaoRisco.id === this.model.classificacaoRiscoId)

            Object.assign(this.item, {
                tipo: {
                    id: tipo.id,
                    descricao: tipo.descricao,
                },
                unidade: this.model.unidadeId ? {
                    id: unidade.id,
                    nomeFantasia: unidade.nomeFantasia
                } : null,
                infraestrutura: this.model.infraestruturaId ? {
                    id: infraestrutura.id,
                    nome: infraestrutura.nome,
                } : null,

                especialidade: this.model.especialidade ? {
                    id: especialidade.id,
                    nome: especialidade.nome ?? especialidade.descricao,
                    descricao: especialidade.descricao ?? especialidade.nome,
                    ocupacaoCodigo: especialidade.ocupacaoCodigo,
                    exigirPesoAlturaCircunferencia: especialidade.exigirPesoAlturaCircunferencia,
                } : null,
                complemento: this.model.complemento,
                ciap: this.model.ciap ? {
                    id: this.model.ciap.id,
                    codigo: this.model.ciap.codigo,
                    descricao: this.model.ciap.descricao,
                } : null,
                cid: cid,
                classificacaoRisco: this.model.classificacaoRiscoId ? {
                    id: classificacaoRisco.id,
                    nome: classificacaoRisco.nome,
                    descricaoEncaminhamento: classificacaoRisco.descricaoEncaminhamento
                } : null,
                motivo: this.model.motivo,
                observacao: this.model.observacao,
                internacaoHospitalar: {
                    cidPrincipal: this.model.internacaoHospitalar.cidPrincipal,
                    cidSecundario: this.model.internacaoHospitalar.cidSecundario,
                    cidCausasAssociadas: this.model.internacaoHospitalar.cidCausasAssociadas,
                    unidadeSolicitanteId: this.model.internacaoHospitalar.unidadeSolicitanteId,
                    principaisSinaisSintomasClinicos: this.model.internacaoHospitalar.principaisSinaisSintomasClinicos,
                    condicoesQueJustificamInternacao: this.model.internacaoHospitalar.condicoesQueJustificamInternacao,
                    principaisResultadosDeProvasDiagnosticas: this.model.internacaoHospitalar.principaisResultadosDeProvasDiagnosticas,
                    procedimento: {
                        procedimentoSolicitado: this.model.internacaoHospitalar.procedimento.procedimentoSolicitado,
                        dataSolicitacao: this.model.internacaoHospitalar.procedimento.dataSolicitacao,
                        clinicaId: this.model.internacaoHospitalar.procedimento.clinicaId,
                        caraterInternacaoId: this.model.internacaoHospitalar.procedimento.caraterInternacaoId,
                        profissionalSolicitanteAssistente: this.model.internacaoHospitalar.procedimento.profissionalSolicitanteAssistente,
                        profissionalSolicitanteDocumentoTipoId: this.model.internacaoHospitalar.procedimento.profissionalSolicitanteDocumentoTipoId,
                        profissionalSolicitanteDocumentoNumero: this.model.internacaoHospitalar.procedimento.profissionalSolicitanteDocumentoNumero?.replace(/\D/g, '')
                    },
                    causasExternas: {
                        causaExternaId: this.model.internacaoHospitalar.causasExternas.causaExternaId,
                        cnpjSeguradora: this.model.internacaoHospitalar.causasExternas.cnpjSeguradora?.replace(/\D/g, ''),
                        numeroBilhete: this.model.internacaoHospitalar.causasExternas.numeroBilhete,
                        serie: this.model.internacaoHospitalar.causasExternas.serie,
                        cnpjEmpresa: this.model.internacaoHospitalar.causasExternas.cnpjEmpresa?.replace(/\D/g, ''),
                        cnaeEmpresa: this.model.internacaoHospitalar.causasExternas.cnaeEmpresa?.replace(/\D/g, ''),
                        cbor: this.model.internacaoHospitalar.causasExternas.cbor,
                        vinculoPrevidenciaId: this.model.internacaoHospitalar.causasExternas.vinculoPrevidenciaId,
                    },
                    autorizacao: {
                        profissionalAutorizador: this.model.internacaoHospitalar.autorizacao.profissionalAutorizador ?? null,
                        dataAutorizacao: this.model.internacaoHospitalar.autorizacao.dataAutorizacao,
                        codigoOrgaoEmissor: this.model.internacaoHospitalar.autorizacao.codigoOrgaoEmissor,
                        profissionalAutorizadorDocumentoTipoId: this.model.internacaoHospitalar.autorizacao.profissionalAutorizadorDocumentoTipoId,
                        profissionalAutorizadorDocumentoNumero: this.model.internacaoHospitalar.autorizacao.profissionalAutorizadorDocumentoNumero?.replace(/\D/g, '')
                    }
                },
            })
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return
                    const encaminhamento = this.data.model.encaminhamentos.find(encaminhamento => {
                        if (encaminhamento.tipo.id === this.enums.encaminhamento.ENCAMINHAMENTO_PARA_SERVICO_ESPECIALIZADO) {
                            const especialidadeId = this.getSafely(() => encaminhamento.especialidade.id)
                            const cidId = this.getSafely(() => encaminhamento.cid.id)

                            return especialidadeId === this.model.especialidadeId && cidId === this.model.cid.id
                        } else {
                            return encaminhamento.tipo.id === this.model.tipoId
                        }
                    })

                    if (!this.item && encaminhamento) {
                        this.showValidationNotification('O encaminhamento já foi incluído.')
                        return
                    }

                    const request = {
                        pacienteId: this.data.additionals.paciente.id,
                        especialidadeId: this.model.especialidade?.id ?? this.model.especialidadeId ?? null,
                    }

                    this.setLoading()

                    this.repositories.atendimento.encaminhamentoPendente(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {

                            const include = () => {

                                if (this.item) {
                                    this.update()
                                } else {
                                    this.store()
                                }

                                this.$refs.RkmModal.hide()
                            }

                            if (response.data && (this.model.tipoId === this.enums.encaminhamento.ENCAMINHAMENTO_PARA_SERVICO_ESPECIALIZADO)) {

                                if (this.data.additionals.permiteEncaminharRepetido) {

                                    this.showWarningConfirmation(
                                        'Atenção',
                                        'Este paciente já possui uma solicitação em aberto para a especialidade na regulação. Deseja continuar?',
                                        async () => include()
                                    )
                                } else {

                                    this.showAlert('Este paciente já possui uma solicitação em aberto para a especialidade na regulação.', "Atenção");
                                }
                            } else {
                                include()
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        resetForm() {
            this.model.tipoId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidade = null
            this.model.especialidadeId = null
            this.model.complemento = null
            this.model.ciap = null
            this.model.cid = null
            this.model.cidId = null
            this.model.classificacaoRiscoId = this.enums.classificacaoRisco.NAO_AGUDA
            this.model.motivo = null
            this.model.observacao = null
            this.model.sugestao = false
            this.model.internacaoHospitalar = {
                cidPrincipal: null,
                cidSecundario: null,
                cidCausasAssociadas: null,
                unidadeSolicitanteId: null,
                principaisSinaisSintomasClinicos: null,
                condicoesQueJustificamInternacao: null,
                principaisResultadosDeProvasDiagnosticas: null,
                procedimento: {
                    procedimentoSolicitado: null,
                    dataSolicitacao: null,
                    clinicaId: null,
                    caraterInternacaoId: null,
                    profissionalSolicitanteAssistente: null,
                    profissionalSolicitanteDocumentoTipoId: null,
                    profissionalSolicitanteDocumentoNumero: null
                },
                causasExternas: {
                    causaExternaId: null,
                    cnpjSeguradora: null,
                    numeroBilhete: null,
                    serie: null,
                    cnpjEmpresa: null,
                    cnaeEmpresa: null,
                    cbor: null,
                    vinculoPrevidenciaId: null,
                },
                autorizacao: {
                    profissionalAutorizador: null,
                    dataAutorizacao: null,
                    codigoOrgaoEmissor: null,
                    profissionalAutorizadorDocumentoTipoId: null,
                    profissionalAutorizadorDocumentoNumero: null
                }
            }
        },
        handleTipoChange() {
            this.data.form.encaminhamento.intersetorial.infraestruturas = []
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidade = null
            this.model.especialidadeId = null
            this.model.complemento = null
            this.model.ciap = null
            this.model.cid = null
            this.model.cidId = null
            this.model.classificacaoRiscoId = this.enums.classificacaoRisco.NAO_AGUDA
            this.model.motivo = null
        },
        handleUnidadeChange(value, afterList = null) {
            this.data.form.encaminhamento.intersetorial.infraestruturas = []
            this.model.infraestruturaId = null

            if (value === null) return

            const request = {
                origem: 'plano',
                listar: 'encaminhamento-intersetorial-infraestruturas',
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.atendimento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.data.form.encaminhamento.intersetorial.infraestruturas = Object.assign(response.data.infraestruturas)

                    if (this.data.form.encaminhamento.intersetorial.infraestruturas.length === 1) {
                        const selected = this.data.form.encaminhamento.intersetorial.infraestruturas[0]
                        this.model.infraestruturaId = selected.id
                    }

                    if (typeof afterList === 'function') {

                        afterList()
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleCiapSelect(value) {
            if (value.cidId) {
                this.model.cid = {
                    id: value.cidId,
                    codigo: value.cidCodigo,
                    nome: value.cidNome,
                }

                this.model.sugestao = false
            }
        },
        syncInternacaoHospitalarCidPrincipal() {
            if (!this.model.internacaoHospitalar) return

            if (Number(this.model.tipoId) !== this.enums.encaminhamento.ENCAMINHAMENTO_PARA_INTERNACAO_HOSPITALAR) {
                this.model.internacaoHospitalar.cidPrincipal = null
                return
            }

            if (this.model.cid) {
                this.model.internacaoHospitalar.cidPrincipal = this.model.cid
                return
            }

            if (this.model.cidId) {
                const cidSelecionado = this.data.cidSugestao.find(cid => cid.id == this.model.cidId)

                this.model.internacaoHospitalar.cidPrincipal = cidSelecionado ? {
                    id: cidSelecionado.id,
                    codigo: cidSelecionado.codigo,
                    nome: cidSelecionado.nome,
                } : null

                return
            }

            this.model.internacaoHospitalar.cidPrincipal = null
        },
    },
    mixins: [object, repository, stringCase],
    props: {
        data: {required: true, type: Object},
    },
    watch: {
        'model.cid'() {
            this.syncInternacaoHospitalarCidPrincipal()
        },
        'model.cidId'() {
            this.syncInternacaoHospitalarCidPrincipal()
        },
        'model.tipoId'() {
            this.syncInternacaoHospitalarCidPrincipal()
        }
    }
}
</script>